import { useContext } from "react";
import { FuelEconomyContext } from "../context";

export const useFuelEconomy = () => useContext(FuelEconomyContext);